<template>
  <div>
    <div :id="id" :style="{ height: height, width: width }"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
// let color = []
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      let theme = this.option.config.theme
        ? this.option.config.theme
        : [
          '#007EFF',
          '#1EE4DC',
          '#FFD71C',
          '#FF6246',
          '#83CF46',
          '#7159FF',
          '#FFFFFF',
          '#A352FF',
          '#3ED5FF',
          '#F07028'
        ]
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      const OPTIONS = this.option
      let seriesData = []
      if (OPTIONS.config.type && OPTIONS.config.type.indexOf('single') > -1) {
        seriesData = [
          {
            data: (OPTIONS.data || []).map(item => {
              return item.data
            }),
            type: 'bar',
            barGap: 0,
            barWidth: OPTIONS.config.barWidth || 20
          }
        ]
      } else {
        seriesData = (OPTIONS.data || []).map(item => {
          return {
            data: item.data,
            name: item.name,
            type: item.type ? item.type : 'bar',
            stack: OPTIONS.config.stack,
            barGap: 0,
            barWidth: OPTIONS.config.barWidth || 10
          }
        })
      }
      this.chart.setOption({
        color: theme,
        title: {
          text: this.name,
          x: 'left',
          left: '2%',
          top: '-10',
          textStyle: {
            fontSize: 14,
            color: '#fff',
            lineHeight: 40
          }
        },
        legend: {
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 13,
          data: OPTIONS.config.legendData,
          bottom: 10,
          textStyle: {
            fontSize: 12,
            color: '#F1F1F3'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '6%',
          right: '3%',
          bottom: '12%',
          top: this.name ? '15%' : '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: OPTIONS.config.xAxisType
              ? OPTIONS.config.xAxisType
              : 'category',
            data: OPTIONS.config.xData,
            axisLabel: {
              show: OPTIONS.config.axisLabelShowType !== 1,
              // interval: 0,
              color: 'rgba(255,255,255,0.5)',
              rotate: OPTIONS.config.rotate || 0
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)'
              }
            },
            axisLine: {
              show: OPTIONS.config.axisLineShowType !== 1,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)',
                width: 1
              }
            }
          }
        ],
        yAxis: [
          {
            type: OPTIONS.config.yAxisType ? OPTIONS.config.yAxisType : 'value',
            data:
              OPTIONS.config.yAxisType &&
              OPTIONS.config.yAxisType === 'category'
                ? OPTIONS.config.xData
                : [],
            axisLabel: {
              color: '#ffffff',
              margin: 10,
              textStyle: {
                fontSize: 14
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            splitArea: {
              show: false
            }
          }
        ],
        series: seriesData
      })
    }
  },
  created () {}
}
</script>
